import React from "react";
import { CrossBracingSummary } from "./ExtraOptionsSummary";
import CurrencyFormat from "react-currency-format";
import { capitalize } from "../../../redux/reducers/utils";
import { SummaryRow, WallOrientation } from "./Summary";

function resolveDoubleLegLabel({ hasDoubleLeg, hasDoubleLegName, isSingleBaseRail, manufacturerId }) {
	if (!hasDoubleLeg) return "";
	const nameIncludesBaserails = hasDoubleLegName?.includes("Baserails");
	const nameIncludesDouble = hasDoubleLegName?.toLowerCase()?.includes("double");
	const isManufacturer122 = manufacturerId == 122;

	if (!isSingleBaseRail && !nameIncludesBaserails) {
		if (isManufacturer122 && nameIncludesDouble) return `${hasDoubleLegName} / Double Baserail`;
		return nameIncludesDouble ? "Double Legs" : `${hasDoubleLegName} Baserail`;
	}
	return nameIncludesDouble ? "Double Legs" : `${hasDoubleLegName} Baserail`;
}
function EndsSummary({ frontWallName, backWallName, frontWallPrice, backWallPrice }) {
	const fullyEnclosed = frontWallName?.toLowerCase() === "closed" && backWallName?.toLowerCase() === "closed";
	if (fullyEnclosed) {
		return <SummaryRow label={<span className="summary-label-title">{"Ends - Fully Enclosed"}</span>} price={parseFloat(frontWallPrice ?? 0) + parseFloat(backWallPrice ?? 0)} />;
	}
	return (
		<>
			<SummaryRow
				label={
					<>
						<span className="summary-label-title">{"Front End - "}</span>
						<span className="dark-span">{frontWallName}</span>
					</>
				}
				price={frontWallPrice}
			/>
			<SummaryRow
				label={
					<>
						<span className="summary-label-title">Back End</span>
						{" - "}
						<span className="dark-span">{backWallName}</span>
					</>
				}
				price={backWallPrice}
			/>
		</>
	);
}

function SidesSummary({ leftWallName, rightWallName, leftWallPrice, rightWallPrice }) {
	const fullyEnclosed = leftWallName?.toLowerCase() === "closed" && rightWallName?.toLowerCase() === "closed";
	if (fullyEnclosed) {
		return <SummaryRow label={<span className="summary-label-title">{"Sides - Fully Enclosed"}</span>} price={parseFloat(leftWallPrice ?? 0) + parseFloat(rightWallPrice ?? 0)} />;
	}
	return (
		<>
			<SummaryRow
				label={
					<>
						<span className="summary-label-title">{"Right Side - "}</span>
						<span className="dark-span">{rightWallName}</span>
					</>
				}
				price={parseFloat(rightWallPrice ?? 0)}
			/>
			<SummaryRow
				label={
					<>
						<span className="summary-label-title">{"Left Side - "}</span>
						<span className="dark-span">{leftWallName}</span>
					</>
				}
				price={parseFloat(leftWallPrice ?? 0)}
			/>
		</>
	);
}
export function BuildingDimensionSummary({ summaryViewData, standardTrussLabel, trussName, filterLegArr, compareData, showFSCrossHeight, props }) {
	const { params, const_var } = props;
	const heightValue = params.singleSlope == true ? (showFSCrossHeight == true ? params.p_h + " x " + Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12) : params.p_h) : params.p_h;
	const isCompareMode = compareData != undefined && props.item != undefined && (props.item.compareManufactureIndex == "_2" || props.item.compareManufactureIndex == "_1");
	const doubleLegLabel = isCompareMode
		? resolveDoubleLegLabel({
				hasDoubleLeg: compareData.has_double_leg,
				hasDoubleLegName: compareData.hasDoublelegName,
				isSingleBaseRail: compareData.isSingleBaseRail,
				manufacturerId: compareData.manufacturerId
			})
		: params.p_e_l && filterLegArr !== false && filterLegArr !== undefined && filterLegArr.length > 0
			? resolveDoubleLegLabel({
					hasDoubleLeg: true,
					hasDoubleLegName: filterLegArr[0].name,
					isSingleBaseRail: const_var.isSingleBaseRail,
					manufacturerId: summaryViewData?.manufacturer
				})
			: "";
	const resolveTrussLabel = () => {
		if (!trussName || trussName === "") return standardTrussLabel;
		if (trussName.label != undefined && trussName.label != null) {
			if (trussName.is_default == true && params.m_s_n == 153) return standardTrussLabel;
			if (trussName.label != undefined) return trussName.label;
			return standardTrussLabel;
		}
		if (props.item != undefined && props.item?.compareManufactureIndex != "0") return summaryViewData?.truss_type_name;
		if (trussName?.name.includes(params.trussType) == true && trussName.is_default == true) return standardTrussLabel;
		if (summaryViewData?.manufacturer == 153) return "Ladder Truss";
		return "High Truss";
	};

	return (
		<div className="highlight-with-bg">
			<div className="dimension-summary">
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Size</span>
							{" - "}
							<span className="dark-span">{summaryViewData?.roof_style_name ?? 0}</span>
							{" - "}
							<span className="dark-span">
								{params.p_w + "'W x " + params.p_d}'L{" "}
								{params.frame_length != undefined && params.frame_length != 0 && (
									<span>
										Roof Length {" - "}
										{params.p_d + params.frame_length}'
									</span>
								)}
							</span>
						</>
					}
					price={summaryViewData?.roof_style_price != null ? (summaryViewData?.roof_style_price ?? 0) : undefined}
				/>

				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Height</span>
							{" - "}
							<span className="dark-span">
								{heightValue}
								{"'H"}
							</span>{" "}
							<span className="f-11">{doubleLegLabel}</span>
						</>
					}
					price={summaryViewData?.height_price != null ? (summaryViewData?.height_price ?? 0) : undefined}
				/>

				{summaryViewData?.roof_pitch != undefined && (
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Roof Pitch</span>
								{" - "}
								<span className="dark-span">{summaryViewData != undefined ? (summaryViewData?.roof_pitch_custom_name ?? summaryViewData?.roof_pitch_name ?? "") : 0}</span>
							</>
						}
						price={summaryViewData?.roof_pitch_price != null ? (summaryViewData?.roof_pitch_price ?? 0) : undefined}
					/>
				)}

				{trussName != undefined && (
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Truss Name</span>
								{" - "}
								<span className="dark-span">{resolveTrussLabel()}</span>
							</>
						}
						price={summaryViewData?.truss_price != null ? (summaryViewData?.truss_price ?? 0) : undefined}
					/>
				)}
				<SummaryRow
					label={
						<>
							<span className="summary-label-title">Gauge</span>
							{" - "}
							<span className="dark-span">{summaryViewData?.gauge ?? 0} GA</span>
						</>
					}
				/>
				{summaryViewData != undefined && summaryViewData.isBreezeway && (
					<SummaryRow
						label={
							<>
								<span className="summary-label-title">Breezeway Length</span>
								{" - "}
								<span className="dark-span">{summaryViewData?.breezeway_length ?? ""} Feet</span>
							</>
						}
						price={0}
					/>
				)}
			</div>
		</div>
	);
}

export function BuildingWallsSummary({ summaryViewData, params, const_var, cbLeftWallName, cbRightWallName, side_close_cost_check }) {
	const showWallOrientation =
		params.p_f_w !== "Open" ||
		params.p_b_w !== "Open" ||
		params.p_l_w !== "Open" ||
		params.p_r_w !== "Open" ||
		params.p_c_p_r == true ||
		params.p_c_p_l == true ||
		params.cB_addStorage_check_right == true ||
		params.cB_addStorage_check_left == true ||
		params.cB_addStorage_check_front == true ||
		params.p_u_c == true;
	const frontWallName = const_var.TypeWallName[summaryViewData != undefined ? summaryViewData.front_wall : 0];
	const backWallKey =
		summaryViewData != undefined && summaryViewData?.has_utility == true && summaryViewData?.utility_position != undefined && summaryViewData.utility_position == 0
			? "close"
			: summaryViewData != undefined
				? summaryViewData.back_wall
				: "open";
	const backWallName = const_var.TypeWallName[backWallKey];

	const utilityLabel =
		summaryViewData?.utility_name === "back"
			? `Utility Storage ${
					summaryViewData.utility_position != undefined && summaryViewData.utility_position != 0 ? "(" + Math.round(summaryViewData.utility_position) + "' from Back)" : ""
				} - ${summaryViewData?.utility_length ?? 0} Feet`
			: `${capitalize(summaryViewData?.utility_name)} Storage - ${summaryViewData?.utility_length ?? 0} Feet`;
	return (
		<div className="highlight-with-bg">
			<EndsSummary
				frontWallName={frontWallName}
				backWallName={backWallName}
				frontWallPrice={summaryViewData?.front_wall_price != null ? (summaryViewData?.front_wall_price ?? 0) : undefined}
				backWallPrice={summaryViewData?.back_wall_price != null ? (summaryViewData?.back_wall_price ?? 0) : undefined}
			/>
			<SidesSummary leftWallName={cbLeftWallName} rightWallName={cbRightWallName} leftWallPrice={summaryViewData?.left_wall_price} rightWallPrice={summaryViewData?.right_wall_price} />
			{(summaryViewData?.has_utility == true || summaryViewData?.has_utility_front) && (
				<div>
					<div className="highlight-with-bg">
						<SummaryRow
							label={<span className="summary-label-title">{utilityLabel}</span>}
							price={summaryViewData?.utility_price != null && summaryViewData?.utility_price != undefined ? (summaryViewData?.utility_price ?? 0) : undefined}
						/>
					</div>
					<hr />
				</div>
			)}
			{showWallOrientation && <WallOrientation side_close_cost_check={side_close_cost_check} summaryViewData={summaryViewData} params={params} />}
			{summaryViewData?.extra_items && <CrossBracingSummary options={summaryViewData?.extra_items} mainData={summaryViewData} />}
		</div>
	);
}
